import { Navigate, useLocation } from "react-router-dom";
// HOOK

import { CheckToken } from "app/apiCall/Postapi";
import { getRoleFromToken } from "app/utils/decodeJwtRole";

const checktokenAll = async()=>{
  
  try {
     const tokenValidation = await CheckToken()
     
  } catch (error) {
     console.log("authonotication failled",error);
     
  }
}

export function AuthGuard({ children }) {
  
  const location = useLocation();

  const currentPath = location?.pathname;
  
  const isAuthenticated =localStorage.getItem("id") && localStorage.getItem("GymId");
    let userRole = ""; 
  
    checktokenAll()

  // Role comes straight off the JWT's own `type` claim (admin.controller.js's
  // login already signs {id, userName, type}) rather than a separate
  // "tokenVender"==="Raitwar" / "tokenSubVender"==="Rohit" tag that had to
  // be hand-kept in sync with it -- see decodeJwtRole.js.
  const tokenRole = getRoleFromToken(localStorage.getItem("Ankit"));
  if (tokenRole === "Vendor") {
    userRole = "vendor";
  }
  if (tokenRole === "Subvendor") {
    userRole = "member";
  }

  // alert(userRole)

  // If the user is not authenticated, redirect to the login page
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (userRole === "vendor") {
    return children;
  }

  if (userRole === "") {
    return <Navigate to="/" />;
  }

  if(currentPath === '/member-dashboard'){
    return children;
  }

  const rolePermissions = {
    admin: ["/admin", "/vendor-dashboard", "/member-area"], // Admin has access to all routes
    vendor: ["/dashboard/default"], // Vendor has access to specific routes
    member: [
      "/gymProfile",
      "/member-dashboard",
      "/bookings",
      "/checkin",
      "/checkPassCode",
      "/customerFeedback",
      "/banking",
      "/partner-password-change"
    ],
    member2: [
      "/gymProfile",
      "/member-dashboard",
      "/bookings",
      "/checkin",
      "/checkPassCode",
      "/customerFeedback",
    ],
    member3: [
      "/gymProfile",
      "/member-dashboard",
      "/checkin",
      "/checkPassCode",
      "/customerFeedback",
    ], // Member has access to other specific routes
    member4: [
      "/member-dashboard",
      "/checkin",
      "/checkPassCode",
      "/customerFeedback",
    ], // Member has access to other specific routes
  };

  // Check if the current route is accessible for the user's role

  
    let newPath = currentPath.replace("/", "");

    if (!rolePermissions[userRole]?.includes(currentPath)) {
      const previousUrl = document.referrer;
     
  
      return <Navigate to="/" />;
  
      // return  <Navigate to="/" />;
    }
     
   


   
   let rollData = localStorage.getItem('subvender_role')
    // console.log("rollData", rollData);
  //  rollData = rollData?.split(",")
  rollData+= ",member-dashboard,partner-password-change"
  // console.log("rollData", rollData);
  
  
   let bb = rollData?.includes(newPath)
  
   if(bb){
    
    return children
   }
   else{
    // alert("You are not authorized to access this page");
    // return children;
    return <Navigate to='/member-dashboard' />
   }

 



  // return  ( localStorage.getItem("id") && localStorage.getItem('GymId') )? children : <Navigate to="/" />
}

export function AuthGuardAdmin({ children }) {
  
  const { pathname } = useLocation();

  checktokenAll()

  return getRoleFromToken(localStorage.getItem("Ankit")) === "Admin" ? children : <Navigate to="/" />;

  // return <Navigate replace to="/" state={{ from: pathname }} />;
}
